import { Component, Input } from '@angular/core';
import { dateFormat, IWebhook, UICallHistoryItem } from '../../../models/company-call-history/company-call-history.model';
import { IWebhookStatuses } from 'voxloud-types/dist/models';

@Component({
  selector: 'webhook-list',
  templateUrl: './webhook-list.component.html',
  styleUrls: [
    './webhook-list.component.scss',
    '../company-call-history-common-list-style.scss'
  ]
})
export class WebhookListComponent {
  @Input() callItem: UICallHistoryItem;
  @Input() language: string = 'it';

  public groupedByRuleName: {
    [key: string]: IWebhook;
  }

  public dateFormat = dateFormat;
  public IWebhookStatuses = IWebhookStatuses;

  ngOnInit(): void {
    this.groupByRuleName();
  }

  public groupByRuleName(): void {
    this.groupedByRuleName = this.callItem.webhooks.reduce((result, item) => {
      const key = item.rule_name || 'events.company-call-history.detail.webhook.fields.deleted';
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(item);
      return result;
    }, {});
  }
}
